import LoyaltyClaimPointsAccepted from 'pages/loyalty/loyalty-claim-points/loyalty-claim-points-accepted';

export default function ClaimPointsAcceptedPage() {
  return <LoyaltyClaimPointsAccepted />;
}
